import PropTypes from 'prop-types';
import { FeatureFlagPropType } from './common';

const OrganizationFeatureFlagPropType = PropTypes.shape({
  active: PropTypes.bool,
  featureFlag: FeatureFlagPropType
});

export default OrganizationFeatureFlagPropType;
